import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useContext, createContext } from 'react';
import { createIntl, createIntlCache } from 'react-intl';
export const I18nContext = createContext(undefined);
export const useI18n = () => useContext(I18nContext);
const intlCache = createIntlCache();
const I18n = ({ localization, children }) => {
    const [intl, setIntl] = useState(createIntl(localization.selectTranslationsByBrowser(), intlCache));
    const selectLocale = (locale) => {
        setIntl(createIntl(localization.selectTranslations(locale), intlCache));
    };
    return (_jsx(I18nContext.Provider, { value: { intl, selectLocale }, children: children }));
};
export default I18n;
